'use client';
import classes from './CategoriesDiscover.module.css';
import locations from '@/utils/locations';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

const CategoriesContentText = (props) => {
	const {
		locationCity,
		brand,
		category,
		option,
		subType,
		capitalizeEachWord,
		style,
		room,
		searchTerm,
		sortCriteria,
	} = props;

	const pathname = usePathname();

	const categoryParam =
		pathname.split('/').at(1) === 'collections'
			? pathname.split('/').at(2)
			: null;
	const optionParam =
		pathname.split('/').at(1) === 'collections'
			? pathname.split('/').at(3)
			: null;
	const typeParam =
		pathname.split('/').at(1) === 'collections'
			? pathname.split('/').at(4)
			: null;
	const brandParam =
		pathname.split('/').at(1) === 'brand' ? pathname.split('/').at(2) : null;
	const styleParam =
		pathname.split('/').at(1) === 'style' ? pathname.split('/').at(2) : null;
	const locationParam =
		pathname.split('/').at(1) === 'location' ? pathname.split('/').at(2) : null;
	const roomParam =
		pathname.split('/').at(1) === 'room' ? pathname.split('/').at(2) : null;

	const contentData = {
		default: {
			header: 'Preloved Furniture',
			subheader: 'Vintage Charm, Modern Twist',
			text: 'Explore second-hand treasures: quaint tables, alluring sofas, and vintage desks full of character',

			options: {},
		},
		seating: {
			header: 'Seating',
			subheader:
				'An Armchair or a Sofa? Or maybe something to dine or work on?',
			text: "A mid century-modern dining chair? A Hermann Miller office chair? How about a sofa under $300? Or the coolest accent chair to impress? It's up to you!",
			options: {
				chairs: {
					header: 'Chairs',
					subheader: 'Soo many chairs!',
					text: 'Arne Jacobsen accent chairs, Hermann Miller office chairs, Ethan Allen side chairs, Scandinavian dining chairs and so much more - making a decision wont be easy!',
					options: {
						'accent-chairs': {
							header: 'Accent Chairs',
							subheader: 'Cheers to those accents',
							text: "Mid century lounge chairs, Hermann Miller side chairs, cute armchairs or Knoll design classics - we've got something to suit your taste.",
						},
						'dining-chairs': {
							header: 'Dining Chairs',
							subheader: 'Delightful Dining',
							text: 'Unique dining chairs made of oak, teak, metal or plastic. From vintage, to mid century to modern, as a set, batch single or to mix and match - enjoy browsing!',
						},
						'office-chairs': {
							header: 'Office Chairs',
							subheader: 'Work Work Work Work',
							text: "Or Relax - since theres no need to always work on a comfortable Hermann Miller Aeron. We're here to match your needs with comfort and style, so you can sit back and enjoy that productive day with a back supporting beauty.",
						},
						'swivel-chairs': {
							header: 'Swivel Chairs',
							subheader: 'Swivel Swivel',
							text: 'Swivel chairs are not just for the office. We have a variety of swivel chairs for your living room, bedroom or office. From vintage to modern, we have something for everyone.',
						},
					},
				},
				sofas: {
					header: 'Sofas',
					subheader: 'So good, so comfy',
					text: 'Loveseats for two, sofas for more, or that sectional to fit them all! Explore our selection of sofas, from vintage to modern, from leather to fabric, from small to large.',
					options: {
						sofas: {
							header: 'Sofas & Couches',
							subheader:
								"...that you'll add to your wishlist 100 times before finally going for it.",
							text: 'From mid century modern to modern, from leather to fabric, from small to large, from vintage to modern - we have something for everyone.',
						},
						sectionals: {
							header: 'Sectionals',
							subheader: 'Spacious & Sociable',
							text: 'Spend time with family and friends on a spacious sectional from Crate & Barrel, West Elm, Pottery Barn or else.',
						},
						loveseats: {
							header: 'Loveseats',
							subheader: 'Cozy and Compact',
							text: "De Sede loveseats that stand the test of time, or a West Elm loveseat that's perfect any space you want to cozy up.",
						},
					},
				},

				armchairs: {
					header: 'Armchairs',
					subheader: 'Sink into Comfort',
					text: 'Pottery Barn, La-Z-Boy, De Sede, or how about some scandinavian teak wooden ones? The choice is yours.',
					options: {
						'arm-chairs': {
							header: 'Arm Chairs',
							subheader: 'Elegance & Comfort',
							text: 'Vintage to mid-century to modern, leather to fabric, with great choice comes great responsibility.',
						},
						'rocking-chairs': {
							header: 'Rocking Chairs',
							subheader: 'Rock to Relax',
							text: 'Rocking chairs are not just for the nursery. We have a variety of rocking chairs for your living room, bedroom or office. From vintage to modern, we have something for you.',
						},
						'club-chairs': {
							header: 'Club Chairs',
							subheader: 'Sit yourself down',
							text: '...into the most comfortable chair you can find. Would you like a vintage leather club chair or that modern one from Restoration Hardware? We have them all.',
						},
						recliners: {
							header: 'Recliners',
							subheader: 'Relax & Unwind',
							text: 'Recline your way to relaxation with a modern recliner from La-Z-Boy. Or what about one of those vintage ones?',
						},
					},
				},
				stools: {
					header: 'Stools',
					subheader: 'Sit up high, or low - who are we to tell you?',
					text: 'Bar stools, counter stools, or a low for your vanity. We have them all, from vintage to modern, from wood to metal, from leather to fabric.',
					options: {
						'bar-stools': {
							header: 'Bar Stools',
							subheader: 'Raise the Bar',
							text: '...with a set of mid century modern bar stools or a modern set from West Elm.',
						},
						'low-stools': {
							header: 'Low Stools',
							subheader: 'Low & Lovely',
							text: 'Low stools for those piano lessons you wanted to take? Or how about a set for your living room?',
						},
					},
				},
				benches: {
					header: 'Benches',
					subheader: 'Good to meet you, Bench!',
					text: 'In the entrence to take off your shoes, the dining room to fit more people, or the living room to put your feet up. Benches are undoubtedly a versatile friend.',
				},

				'chaises-and-daybeds': {
					header: 'Chaises & Daybeds',
					subheader: 'To take a nap, or not to take a nap?',
					text: 'Resting, reading or lounging - chaises and daybeds make for a comforable and stylish addition to any room.',
				},

				'ottomans-and-footstools': {
					header: 'Ottomans & Footstools',
					subheader: "To rest those feet - they've been walking you all day",
					text: 'As a set with an armchair, or as a standalone piece, ottomans bring comfort to any room.',
				},
			},
		},

		storage: {
			header: 'Storage',
			subheader: 'Where Clutter Meets Its Match',
			text: "Overflowing closets? Books scattered all over? Or perhaps, a cocktail setup longing for a home? Whatever your dilemma, we've got the stylish solution to tidy up in style.",

			options: {
				'bookcases-and-shelving': {
					header: 'Bookcases & Shelving',
					subheader: 'Elevate Your Reads',
					text: 'Show off your literary collection or your knick-knack treasures on something as stylish as they are. From sleek, modern designs to charming, vintage finds - your walls will thank you.',
				},
				'dressers-and-chests-of-drawers': {
					header: 'Dressers & Chests of Drawers',
					subheader: 'Stow in Style',
					text: "Where fashion meets function, these pieces are not just for your clothes. They're a statement. Modern, vintage, or somewhere in-between, find your perfect match.",
				},
				'sideboards-and-credenzas': {
					header: 'Sideboards & Credenzas',
					subheader: 'Sleek Storage Heroes',
					text: 'Not just a dining room staple, but a versatile piece for any room. Store, display, and impress with our range of sideboards and credenzas. The ultimate clutter-busters.',
				},
				nightstands: {
					header: 'Nightstands',
					subheader: 'By Your Side, Night & Day',
					text: 'The unsung heroes of the bedroom, keeping your essentials within reach. Whether you lean towards minimalist designs or something with a bit more flair, we’ve got your back.',
				},
				'armoires-and-wardrobes': {
					header: 'Armoires & Wardrobes',
					subheader: 'Closet Envy',
					text: 'Space for everything, and everything in its space. From spacious wardrobes to elegant armoires, organize in style and make the search for that one shirt a breeze.',
				},
				'trunks-and-chests': {
					header: 'Trunks & Chests',
					subheader: 'Treasure Troves',
					text: "Not just for pirates, these trunks and chests are perfect for storing blankets, memories, or even gold (if you're into that). A charming addition to any room.",
				},
				'bar-carts': {
					header: 'Bar Carts',
					subheader: 'Roll in the Good Times',
					text: 'Cocktail hour just got a major upgrade. Serve up drinks or create a mobile vignette of your favorite decor. Cheers to versatility and good looks.',
				},
				'storage-and-display-cabinets': {
					header: 'Storage & Display Cabinets',
					subheader: 'Show and Tell, or Hide away?',
					text: 'Why hide away your prized possessions when you can display them with pride? From delicate glasses to your action figure collection, we have the perfect spotlight (or not).',
				},
			},
		},

		beds: {
			header: 'Beds',
			subheader: 'Nestle into Nighttime Bliss',
			text: 'Big dreams start with the right bed. King or single, find your perfect snooze spot and dive into comfort every night.',

			options: {
				'bed-frames': {
					header: 'Bed Frames',
					subheader: 'Foundations for Sweet Dreams',
					text: 'Metal or wood, sleek or ornate - pick your frame, pick your vibe. The perfect start to a restful night’s embrace.',
				},
				headboards: {
					header: 'Headboards',
					subheader: 'Pillow Backdrops with Personality',
					text: "From plush upholsteries to intricate carvings, our headboards add a touch of 'you' to any bedroom, making it truly yours.",
				},
			},
		},

		'tables-and-desks': {
			header: 'Tables & Desks',
			subheader: 'Work, Dine, or Just Show Off',
			text: 'From functional to decorative, find tables and desks that fit your life and style. Featuring top picks from Pottery Barn, West Elm, Crate & Barrel, and Restoration Hardware.',

			options: {
				tables: {
					header: 'Tables',
					subheader: "Gather 'Round",
					text: 'Center your space with statement pieces that invite conversation and camaraderie.',
					options: {
						'dining-tables': {
							header: 'Dining Tables',
							subheader: 'Feast in Style',
							text: 'From intimate dinners to grand gatherings, find your next dining masterpiece from brands like Pottery Barn and Crate & Barrel.',
						},
						'coffee-tables': {
							header: 'Coffee Tables',
							subheader: 'Centerpiece Chic',
							text: 'Anchor your living area with a stylish coffee table from West Elm or Restoration Hardware. Perfect for decor, books, or resting your feet.',
						},
						'accent-and-side-tables': {
							header: 'Accent & Side Tables',
							subheader: 'Small in Size, Big on Style',
							text: 'Add a touch of elegance with accent and side tables from Crate & Barrel, perfect for lamps, plants, or your coffee cup.',
						},
						'console-tables': {
							header: 'Console Tables',
							subheader: 'Sophisticated Entryways',
							text: 'Greet your guests with a stylish console table from Pottery Barn, an ideal spot for keys, mail, and showcasing your style.',
						},
					},
				},
				desks: {
					header: 'Desks',
					subheader: 'Where Ideas Come to Life',
					text: 'Craft your next masterpiece or manage the day-to-day on a desk that inspires productivity and creativity.',
					options: {
						desks: {
							header: 'Desks',
							subheader: 'Functional Elegance',
							text: 'From spacious workstations to minimalist designs, find the desk that meets your work and aesthetic needs.',
						},
						'secretary-desks': {
							header: 'Secretary Desks',
							subheader: 'Classic Charm',
							text: 'Tuck away work at the end of the day with a traditional secretary desk, combining functionality with timeless style.',
						},
						'vanity-desks': {
							header: 'Vanity Desks',
							subheader: 'Beauty Meets Productivity',
							text: 'Merge beauty and work with a vanity desk, the perfect spot for morning routines and late-night emails.',
						},
					},
				},
			},
		},

		lighting: {
			header: 'Lighting',
			subheader: 'Set the Mood or Light the Stage',
			text: "Desk lamp for those late-night reads? Or maybe a floor lamp to spotlight your favorite nook? Let's brighten things up!",

			options: {
				'desk-lamps': {
					header: 'Desk Lamps',
					subheader: 'And there was light!',
					text: 'Whether it’s for work, reading, or just setting the ambiance, explore a glow  from selections spaning vintage to mid-century, industiral to modern.',
				},
				'floor-lamps': {
					header: 'Floor Lamps',
					subheader: 'Stand Tall & Shine',
					text: 'Illuminate your corners or cozy reading spots with our stylish floor lamps. How about industrial or mid-century, or something under $100? .',
				},
				'table-lamps': {
					header: 'Table Lamps',
					subheader: 'Whats on your table?',
					text: 'From vintage to modern, we have a variety of table lamps to brighten up your space. Perfect for your nightstand, side table, or console table.',
				},
				'ceiling-and-wall-lamps': {
					header: 'Ceiling & Wall Lamps',
					subheader: 'Overhead & On Point',
					text: "Light up your room from above. Ceiling and wall lamps from vintage to mid-century modern, we've got somethign to suit your taste.",
				},
			},
		},

		decor: {
			header: 'Decor',
			subheader: 'The Final Touches',
			text: 'There it is, the final touch that makes your home yours. From surpising objects, to functional decorative items. Find the perfect accents to create your style.',

			options: {
				'decorative-accessories': {
					header: 'Decorative Accessories',
					subheader: 'Chic Touches Everywhere',
					text: 'Tiny details, big impact. Let’s find the perfect accents to tell your story.',
					options: {
						vases: {
							header: 'Vases',
							subheader: 'Elegance in Bloom',
							text: 'Whether overflowing with flowers or standing solo, our vases add a touch of grace.',
						},
						'sculptures-and-statues': {
							header: 'Sculptures & Statues',
							subheader: 'Artful Expressions',
							text: 'Make a statement with pieces that speak volumes, from the abstract to the classic.',
						},
						'decorative-accents': {
							header: 'Decorative Accents',
							subheader: 'Personality Pieces',
							text: 'Bits and bobs that make a room feel like yours, from quirky to sophisticated.',
						},
						'kitchen-accessories': {
							header: 'Kitchen Accessories',
							subheader: 'Culinary Charms',
							text: 'Spice up your kitchen space with accessories that blend function and flair.',
						},
					},
				},
				'room-dividers': {
					header: 'Room Dividers',
					subheader: 'Divide & Conquer',
					text: 'Create intimate spaces or open floor plans with dividers that double as art.',
				},
				mirrors: {
					header: 'Mirrors',
					subheader: 'Reflections of Style',
					text: 'Expand your space and style with mirrors that make every room look bigger and brighter.',
					options: {
						'wall-mirrors': {
							header: 'Wall Mirrors',
							subheader: 'Wall Candy',
							text: 'From functional to decorative, wall mirrors that reflect your personal taste.',
						},
						'full-length-and-floor-mirrors': {
							header: 'Full Length & Floor Mirrors',
							subheader: 'Head-to-Toe Style',
							text: 'Check out your look in our full-length mirrors, perfect for any corner.',
						},
					},
				},
				'rugs-and-carpets': {
					header: 'Rugs & Carpets',
					subheader: 'Ground Your Space',
					text: 'Lay the foundation of your room with rugs and carpets that tie everything together.',
					options: {
						carpets: {
							header: 'Carpets',
							subheader: 'Plush Steps',
							text: 'Soft underfoot and pleasing to the eye, our carpets bring warmth and comfort.',
						},
						runners: {
							header: 'Runners',
							subheader: 'Linear Elegance',
							text: 'Hallways or entryways, our runners add a dash of decor and function.',
						},
					},
				},
				'wall-art': {
					header: 'Wall Art',
					subheader: 'Speak Without Words',
					text: 'Fill your walls with expressions, colors, and frames that tell your unique story.',
					options: {
						paintings: {
							header: 'Paintings',
							subheader: 'Canvas Conversations',
							text: 'From abstracts to landscapes, paintings that stir the soul and spark conversation.',
						},
						'picture-frames': {
							header: 'Picture Frames',
							subheader: 'Memories on Display',
							text: 'Frame your cherished moments in styles that complement your decor.',
						},
						'wall-decorative-accents': {
							header: 'Wall Decorative Accents',
							subheader: 'Decor Drama',
							text: 'Add layers and texture to your walls with accents that pop.',
						},
					},
				},
			},
		},

		6: {
			header: 'Best Deals',
			subheader: 'Top Brands, Great Prices',
			text: 'Score top deals on high-quality, gently used furniture.',
			options: {},
		},
		3: {
			header: 'Just In',
			subheader: 'New Arrivals, Every Day',
			text: 'Daily new treasures, each ready to add unique flair and history to your space.',
			options: {},
		},
		branded: {
			header: 'Branded Furniture',
			subheader: 'Top Brands, Great Prices',
			text: 'Uncover fantastic deals on premium pre-loved furniture, without stretching your wallet.',
			options: {},
		},
		brand: {
			header: capitalizeEachWord(brand),
			subheader: `${capitalizeEachWord(
				subType ? subType : option ? option : category ? category : 'furniture'
			)}`,
			text: `Explore our collection of ${capitalizeEachWord(
				brand
			)} furniture, at prices that please.`,
			options: {},
		},
		room: {
			header: capitalizeEachWord(room),
			subheader: `${capitalizeEachWord(
				subType ? subType : option ? option : category ? category : 'furniture'
			)}`,
			text: `Explore our collection of ${capitalizeEachWord(
				room
			)} furniture, at prices that please.`,
			options: {},
		},

		style: {
			header: capitalizeEachWord(style),
			subheader: `${capitalizeEachWord(
				subType ? subType : option ? option : category ? category : 'furniture'
			)}`,
			text: `Explore our collection of ${capitalizeEachWord(
				style
			)} furniture, at prices that please.`,
			options: {},
		},
		location: {
			header:
				locations?.find(
					(loc) => loc.id.toLowerCase() === locationCity?.toLowerCase()
				)?.area ?? 'Default Area',
			subheader: `${capitalizeEachWord(
				subType ? subType : option ? option : category ? category : 'furniture'
			)}`,
			text: `Explore our collection of furniture, at prices that please.`,
			options: {},
		},
		search: {
			header: `Search Results for "${searchTerm && searchTerm?.toUpperCase()}"`,
			subheader: 'Preloved & Delivered Nationwide',
			text: 'Explore our collection of second-hand furniture, from vintage to modern, at prices that please.',
			options: {},
		},
	};

	const findMatchingContent = () => {
		let content = null;

		let mainParams = {
			categoryParam,
			optionParam,
			typeParam,
			brandParam,
			styleParam,
			locationParam,
			roomParam,
		};

		let subParams = {
			category,
			option,
			subType,
			brand,
			style,
			locationCity,
			room,
			searchTerm,
			sortCriteria,
		};

		if (Object.values(mainParams).some((param) => param)) {
			if (brandParam) {
				content = contentData['brand'];
			}
			if (categoryParam) {
				content = contentData[categoryParam];
			}
			if (categoryParam && (optionParam || option)) {
				content = content?.options[optionParam || option];
			}
			if (categoryParam && optionParam && typeParam) {
				content = content?.options[typeParam];
			}
			if (locationParam) {
				content = contentData['location'];
			}
			if (roomParam) {
				content = contentData['room'];
			}
			if (styleParam) {
				content = contentData['style'];
			}
		} else if (Object.values(subParams).some((param) => param)) {
			if (searchTerm) {
				content = contentData['search'];
			} else {
				if (brand) {
					content = contentData['brand'];
				}
				if (category && !brand) {
					if (category !== 'undefined') {
						content = contentData[category] ?? contentData[category];
					}
				}
				if (category && option && !brand) {
					if (option !== 'undefined') {
						content = content?.options[option] ?? contentData[option];
					}
				}
				if (category && option && subType && !brand) {
					if (subType !== 'undefined') {
						content = content?.options[subType] ?? contentData[subType];
					}
				}
				if (locationCity) {
					content = contentData['location'];
				}
				if (style) {
					content = contentData['style'];
				}
				if (room) {
					content = contentData['room'];
				}
				if (sortCriteria === '3' || sortCriteria === '6') {
					content = contentData[sortCriteria];
				}
			}
		} else {
			content = contentData.default;
		}
		return content;
	};

	const [matchingContent, setMatchingContent] = useState();

	useEffect(() => {
		setMatchingContent(findMatchingContent());
	}, [props]);

	return (
		<div className={classes.headerBox}>
			{matchingContent ? (
				<>
					<h1 className={classes.header}>{matchingContent.header}</h1>
					<h2 className={classes.subHeader}>{matchingContent.subheader}</h2>
					<p className={classes.descriptiveText}>{matchingContent.text}</p>
				</>
			) : (
				''
			)}
		</div>
	);
};

export default CategoriesContentText;
